"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataTestAttribute = void 0;
var _stringHelper = require("./stringHelper");
var getDataTestAttribute = exports.getDataTestAttribute = function getDataTestAttribute(props, fieldName) {
  return props.dataTest || ((0, _stringHelper.isString)(props[fieldName]) ? props[fieldName] : '');
};